import { CurrentAdminRO } from '@routellers/types/dist/admin/current-admin.ro';

import { ApiMethodDeclaration } from '..';

type ResponseData = CurrentAdminRO;

export const me: ApiMethodDeclaration<undefined, ResponseData> = () => ({
    url: '/admins/me',
    method: 'GET',
});
